import { styled } from "@mui/material/styles";

const Tag = (props) => {
    const { label, ...other } = props;

    return (
        <div {...other}>
            <span>{label}</span>
        </div>
    );
};

const StyledTag = styled(Tag)(
    ({ theme }) => `
        display: flex;
        align-items: center;
        height: 24px;
        margin: 2px;
        line-height: 22px;
        background-color: #f2f3f6;
        border: 1px solid gray;
        border-radius: 2em;
        box-sizing: content-box;
        padding: 0 10px 0 10px;
        outline: 0;
        overflow: hidden;
        cursor: pointer;
        transition: all 200ms ease;
  
        &:focus {
            border-color: ${
                theme.palette.mode === "dark" ? "#177ddc" : "#40a9ff"
            };
            background-color: ${
                theme.palette.mode === "dark" ? "#003b57" : "#e6f7ff"
            };
        }
  
        &:hover {
            background-color: #2155bc;
            border-color: #2155bc;
            color: #fff;
        }
  
        & span {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
        }
  
        & svg {
            font-size: 12px;
            cursor: pointer;
            padding: 4px;
        }
    `
);

const RelatedJiraTicketsSimple = ({ tickets }) => {
    const handleTagClick = (ticket) => {
        window.open(`https://jira.benaroyaresearch.org/browse/${ticket}`, "_blank");
    };

    return (
        <div style={{ display: "flex", flexDirection: "column" }}>
            <div
                style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "4px",
                }}
            >
                {tickets.split(",").map((ticket) => {
                    if (ticket !== "") {
                        return (
                            <a
                                href={`https://jira.benaroyaresearch.org/browse/${ticket}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ textDecoration: "none", color: "inherit" }}
                                onClick={(e) => e.preventDefault()}
                            >
                                <StyledTag
                                    label={ticket}
                                    onClick={() => handleTagClick(ticket)}
                                />
                            </a>
                        );
                    }
                })}
            </div>
        </div>
    );
};

export default RelatedJiraTicketsSimple;
